import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.verifyEmailPage.LogoutAcceptInvitation', {
    title: 'Would you like to Logout?',
    text: "We couldn't find those invitations associated with this account.",
    logout: 'Logout',
    stayLoggedIn: 'Stay Logged In',
});
